import { createActions } from 'redux-actions';
import { HealthClaim } from '@models/HealthClaim';
import { GetHealthClaimParams } from '@apis/HealthClaimApi';

export type State = {
  healthClaim: HealthClaim | null | undefined;
};
export type HealthClaimFetchPayload = GetHealthClaimParams;
export type StateUpdatePayload = Partial<State>;

export const {
  healthClaimFetch,

  stateUpdate,
} = createActions(
  'HEALTH_CLAIM_FETCH',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CLAIM_DETAILS_HEALTH_CLAIM_DETAILS',
  },
);
